import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import withToolboxTourTooltip from 'SelfServeTooltipTour/withToolboxTourTooltip';
import * as TooltipTourActions from './TooltipTourActions';

export class TipsTooltip extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="popover-text">
          {this.props.tips.map(tip => (
            <div className="tips-section">
              <button
                className="tip-link"
                onClick={() => this.props.showToolboxTip(tip.type)}
              >
                {tip.name}
              </button>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

TipsTooltip.defaultProps = {
  showToolboxTip: () => null,
};

TipsTooltip.propTypes = {
  showToolboxTip: PropTypes.func,
  tips: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    showToolboxTip: TooltipTourActions.showToolboxTip,
  }, dispatch)
);

const TipsTooltipWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(TipsTooltip);

export default withToolboxTourTooltip(TipsTooltipWithRedux);



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/TipsTooltip.jsx